import account from "@/core/routes/paths/panel/account";
import home from "@/core/routes/paths/panel/home";
import roles from "@/core/routes/paths/panel/roles";
import admins from "@/core/routes/paths/panel/admins";
import colleagues from "@/core/routes/paths/panel/colleagues";
import publishers from "@/core/routes/paths/panel/publishers";
import settings from "@/core/routes/paths/panel/settings";
import sections from "@/core/routes/paths/panel/sections";
import newsletter from "@/core/routes/paths/panel/newsletter";
import blog from "@/core/routes/paths/panel/blog";
import files from "@/core/routes/paths/panel/files";
import logs from "@/core/routes/paths/panel/logs";
import reports from "@/core/routes/paths/panel/reports";
import pages from "@/core/routes/paths/panel/pages";
import company from "@/core/routes/paths/panel/company";
import research from "@/core/routes/paths/panel/research-plans";
import instruction from "@/core/routes/paths/panel/instruction";
import groups from "@/core/routes/paths/panel/groups";
import multimedia from "@/core/routes/paths/panel/multimedia";
import successStories from "@/core/routes/paths/panel/success-stories";
import phoneNumbers from "@/core/routes/paths/panel/phone-numbers";
import managerialStructure from "@/core/routes/paths/panel/managerial-structure";

export default [
  {
    path: "/",
    redirect: "/home",
    component: () => import("@/layout/Master"),
    children: [
      ...home,
      ...account,
      ...roles,
      ...admins,
      ...colleagues,
      ...publishers,
      ...settings,
      ...newsletter,
      ...blog,
      ...files,
      ...reports,
      ...logs,
      ...pages,
      ...sections,
      ...company,
      ...research,
      ...instruction,
      ...groups,
      ...multimedia,
      ...successStories,
      ...phoneNumbers,
      ...managerialStructure,
    ],
  },
];
